import { render } from "./BlogsCarousel.vue?vue&type=template&id=5e0b0757"
import script from "./BlogsCarousel.vue?vue&type=script&lang=js"
export * from "./BlogsCarousel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__